import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { saveHotelSelectedFilters, saveHotelData } from "../store/actions";
import axios from "axios";
import BASE_URL from "../constants/baseUrls";
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";

const useHotelList = (
    isHotelInternational,
    hotelInformation,
    type,
    uid,
    page,
    hotelSort,
    hotelSelectedFilters,
    setRequestFlag,
    setLoading,
    setIsError,
    setOpenSearchForm,
) => {
    //general variables
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const accessToken = localStorage.getItem("accessToken");
    const { t } = useTranslation();
    const isMountedRef = useRef(true);
    const { checkIn, checkOut, destination, nationality, roomsCount } = hotelInformation;
    const endPoint =
        type === "accommodation"
            ? "/api/v2/reserve/ecotourism/list/"
            : isHotelInternational
            ? "/api/v2/reserve/foreign/accommodation/list/"
            : "/api/v2/reserve/accommodation/list/";

    const getHotelList = async () => {
        try {
            setLoading(true);
            setIsError(false);
            searchParams.delete("action");
            searchParams.delete("hotelId");
            searchParams.delete("tag");
            setSearchParams(searchParams);
            const response = await axios.get(`${BASE_URL}${endPoint}`, {
                params: {
                    sort: hotelSort,
                    city: isHotelInternational ? destination.parto_id : destination.id,
                    check_in: checkIn,
                    check_out: checkOut,
                    adult_count: roomsCount?.adult,
                    child_count: roomsCount?.child,
                    child_ages: roomsCount?.ages,
                    nationality: nationality?.parto_iata,
                    uid: uid,
                    page: page,
                    search: hotelSelectedFilters?.name,
                    price_from: hotelSelectedFilters?.prices?.[0],
                    price_to: hotelSelectedFilters?.prices?.[1],
                    stars: hotelSelectedFilters?.stars,
                },
                headers: {
                    Authorization: accessToken ? `Bearer ${accessToken}` : "",
                },
            });
            if (!isMountedRef.current) return;
            dispatch(saveHotelData(response.data.data));
            setOpenSearchForm(false);
        } catch (error) {
            if (!isMountedRef.current) return;
            dispatch(saveHotelData(null));
            dispatch(saveHotelSelectedFilters(null));
            toast.error(error?.response?.data?.errors?.detail || t("Toast Messages.Error Occurred"), { toastId: "custom-id-yes" });
            setIsError(true);
        } finally {
            if (!isMountedRef.current) return;
            setRequestFlag(false);
            setLoading(false);
        }
    };

    // Clean up on unmount
    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    return { getHotelList };
};

export default useHotelList;
